import * as React from 'react';

import { DatosTelefono } from '../tipos';
import Campo from './Campo';

interface Props {
    telefonos: Array<DatosTelefono>;
    correos: Array<string>;
}

export const CorreosYTelefonos: React.FunctionComponent<Props> = props => {
    const { telefonos, correos } = props;

    return (
        <React.Fragment>
            {correos.map((correo, indice) => (
                <Campo
                    key={indice}
                    etiqueta={
                        correos.length === 1
                            ? 'Correo electrónico'
                            : `Correo electrónico ${indice + 1}`
                    }
                    valor={
                        <a href={`mailto:${correo}`} target='_blank' rel='noopener noreferrer'>
                            {correo}
                        </a>
                    }
                />
            ))}
            {telefonos.map(({ nombre, codArea, numero }, indice) => (
                <Campo key={indice} etiqueta={nombre} valor={'+56 ' + codArea + ' ' + numero} />
            ))}
        </React.Fragment>
    );
};

export default CorreosYTelefonos;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/InformacionGeneral/componentes/CorreosYTelefonos.tsx